import {Injectable} from '@angular/core';
import {IdealHttpClient} from './ideal-http.service';
import {of} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  constructor(private readonly _http: IdealHttpClient) {
  }

  getMatomo() {
    return of('');
  }
}
